import { CHAT_MODAL_HIDE } from 'moduleChat/modules/modal/constants';
import { FSA } from 'flux-standard-action';

const chatModalHide = (): FSA => ({
  type: CHAT_MODAL_HIDE,
});

export { chatModalHide };
